module.exports = __webpack_public_path__ + "media/images/banner-assets/en/banner1-1cd57052adbdcd305125c49c786bcee1.jpg";